export interface ProspectFieldDef {
    key: string;
    label: string;
    required?: boolean;
    aliases: string[];
}

// Known prospect fields a spreadsheet column can be mapped to. `aliases` are
// compared against normalized headers (see normalizeHeader) to auto-guess a
// mapping when the file is first loaded.
export const PROSPECT_FIELDS: ProspectFieldDef[] = [
    { key: 'company', label: 'Raison sociale', required: true, aliases: ['societe', 'société', 'raison sociale', 'entreprise', 'company', 'nom entreprise'] },
    { key: 'displayName', label: 'Nom commercial', aliases: ['nom commercial', 'displayname', 'nom'] },
    { key: 'mail', label: 'Email', aliases: ['email', 'mail', 'adresse mail', 'e-mail'] },
    { key: 'phone', label: 'Téléphone', aliases: ['telephone', 'tel', 'phone', 'portable', 'mobile'] },
    { key: 'phone2', label: 'Téléphone 2', aliases: ['telephone 2', 'tel 2', 'phone2', 'portable 2'] },
    { key: 'contact', label: 'Contact', aliases: ['contact', 'nom contact', 'interlocuteur'] },
    { key: 'contactPoste', label: 'Poste du contact', aliases: ['poste', 'poste du contact', 'fonction'] },
    { key: 'website', label: 'Site web', aliases: ['site web', 'website', 'site internet', 'url'] },
    { key: 'notes', label: 'Notes', aliases: ['notes', 'notes utiles', 'remarques', 'commentaire', 'commentaires'] },
    { key: 'siren', label: 'N° SIREN', aliases: ['siren', 'numero de siren', 'n siren'] },
    { key: 'vatNumber', label: 'N° TVA', aliases: ['tva', 'numero de tva', 'n tva', 'vat', 'numero tva'] },
    { key: 'cibleClient', label: 'Cible client', aliases: ['cible client', 'cible'] },
    { key: 'specificiteClient', label: 'Spécificité client', aliases: ['specificite client', 'specificite'] },
    { key: 'typeTransformation', label: 'Type de transformation', aliases: ['type de transformation', 'transformation'] },
    { key: 'potentialMonthlyRevenue', label: 'CA mensuel envisageable (€)', aliases: ['montant mensuel envisageable', 'ca mensuel', 'ca mensuel envisageable', 'potentialmonthlyrevenue'] },
    { key: 'tags', label: 'Tags', aliases: ['tags', 'tag', 'etiquettes', 'étiquettes'] },
];

// Strips accents/case/punctuation so "Société" and "societe" both match the
// same alias entry regardless of how the source spreadsheet styled its header.
export const normalizeHeader = (header: string): string =>
    header
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/[_-]+/g, ' ')
        .trim();

export const guessFieldForHeader = (header: string): string => {
    const normalized = normalizeHeader(header);
    const match = PROSPECT_FIELDS.find((field) =>
        field.aliases.some((alias) => normalizeHeader(alias) === normalized)
    );
    return match ? match.key : '';
};
